<template>
  <div>
    <div class="row text-center mt-5" style="min-height: 350px;">
      <div class="col">
        <h4>Bienvenido(a)
          <span v-if="user.current" class="name-text">
            {{ getFullName | capitalize }}
          </span>
          al portal de afiliación online.
        </h4>
      </div>
    </div>
  </div>
  <!--
  <div v-loading="loading" class="pp-home">
    <template v-if="errored">
      <div class="d-flex justify-content-center align-items-center">
        <div>
          <span class="pp-icon-warm el-icon-warning-outline"></span>
        </div>
        <div>
          <span
            class="text-h2 text-warning text-center">Ha habido un error al obtener los datos para los gráficos.</span>
        </div>
      </div>
    </template>

    <template v-else>
      <div class="row">
        <div class="col-6">
          <el-button-group>
            <el-button type="primary" size="mini" icon="el-icon-date" @click="changeFilterMonth">
              Este mes
            </el-button>
            <el-button type="success" size="mini" icon="el-icon-stopwatch" @click="changeFilteLastThreeMonths">
              Últimos 3 meses
            </el-button>
            <el-button type="warning" size="mini" icon="el-icon-discover" @click="changeFilterLastYear">
              Este año
            </el-button>
          </el-button-group>
        </div>
      </div>

      <template v-if="!loading">


        <template v-if="media.sm">
          <div class="row mt-5">
            <div class="col-12">
              <chart-affiliation :affiliation="affiliation"></chart-affiliation>
            </div>
          </div>
        </template>
        <template v-else>
          <div class="row mt-5">
            <div class="col-12">
              <chart-affiliation :affiliation="affiliation"></chart-affiliation>
            </div>
          </div>
        </template>
      </template>

    </template>
  </div>

  -->
</template>

<script>
import ChartAffiliation from "@/views/components/ChartAffiliation";
import ChartResignation from "@/views/components/ChartResignation";
import {ButtonGroup} from "element-ui";
import {configuracionService} from "@/api/coreApi";
import ScreenSizeMixin from "@/mixins/ScreenSizeMixin";
import ChartAffiliationWaterfall from "@/views/components/ChartAffiliationWaterfall";
import {mapState} from "vuex";

export default {
  name: "ChartParty",
  components: {
    [ButtonGroup.name]: ButtonGroup,
    ChartResignation,
    ChartAffiliation,
    ChartAffiliationWaterfall
  },
  mixins: [
    ScreenSizeMixin
  ],
  data() {
    return {
      loading: true,
      errored: false,
      affiliation: null,
      resignation: null,
    }
  },
  computed: {
    ...mapState({
      user: state => state.user,
      cognitoInfo: state => state.cognitoInfo,
    }),
    getFullName() {
      const name = JSON.parse(this.cognitoInfo.name)
      if (name !== null) {
        return `${name.nombres[0]} ${name.apellidos[0]} ${name.apellidos[1]}`
      }
      return this.user.current.firstLastName
    }
  },
  beforeMount() {
    //this.getData()
  },
  methods: {
    changeFilterMonth() {
      const body = {
        month: true
      }
      this.getData(body)
    },
    changeFilteLastThreeMonths() {
      const body = {
        lastThreeMonths: true
      }
      this.getData(body)
    },
    changeFilterLastYear() {
      const body = {
        lastYear: true
      }
      this.getData(body)
    },
    getData(body = {month: true}) {
      this.loading = true
      configuracionService.getChartData(body)
        .then((response) => {
          this.$log.debug('getChartData', response.data.statusCode)
          if (response.data.statusCode === 200) {
            const data = JSON.parse(response.data.datos);
            this.$log.debug(data)

            this.affiliation = data.affiliation
            this.activity = data.activity
            this.resignation = data.resignation

            this.loading = false

          } else {
            this.errored = true
            this.showInfo('No hay datos para los gráficos')
          }
        })
        .catch((err) => {
          this.errored = true
          this.$log.fatal('getAffiligetChartDataationViewById', err, err.response, err.request)
          this.showError("Error al cargar los datos")
        })
        .finally(() => {
          this.loading = false
        })
    },
  }
}
</script>

<style lang="scss">
.pp-home {
  min-height: 500px;
}

.pp-icon-warm {
  font-size: 5rem;
}

.name-text {
  font-weight: bold;
  font-size: 28px;
}
</style>
